import Image from '@/components/ui/Image';

type MascotState = 'idle' | 'connecting' | 'success' | 'attention' | 'error' | 'core';
type MascotSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';

const STATE_IMAGE: Record<MascotState, string> = {
  idle: '/mascot/link-idle.png',
  core: '/mascot/link-core.png',
  connecting: '/mascot/link-connecting.png',
  success: '/mascot/link-success.png',
  attention: '/mascot/link-attention.png',
  error: '/mascot/link-error.png',
};

const SIZE_PX: Record<MascotSize, number> = {
  xs: 32,
  sm: 48,
  md: 80,
  lg: 120,
  xl: 200,
  '2xl': 280,
  '3xl': 360,
};

interface LinkMascotProps {
  state?: MascotState;
  size?: MascotSize;
  animate?: boolean;
  caption?: string;
  className?: string;
}

export function LinkMascot({
  state = 'core',
  size = 'md',
  animate = false,
  caption,
  className = '',
}: LinkMascotProps) {
  const px = SIZE_PX[size];

  return (
    <div className={`flex flex-col items-center gap-2 ${className}`}>
      <Image
        src={STATE_IMAGE[state]}
        alt={`Link mascot — ${state}`}
        width={px}
        height={px}
        className={animate ? 'animate-mascot-float' : ''}
        priority={size === 'lg' || size === 'xl'}
      />
      {caption && (
        <p className="text-xs font-semibold text-text-tertiary">{caption}</p>
      )}
    </div>
  );
}
